import { useEffect, useRef } from 'react';
import { Button } from '../UI/Button/Button';
import Textarea from '../UI/Form/Textarea/Textarea';

type AIFormulaTextareaProps = {
  aiFormulaQuery: string;
  setAiFormulaQuery: (v: string) => string;
  isLoading: boolean;
  handleGenerateFormulaButtonClick: (v: string) => void;
  handleKeyDownGeneratePreview: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void;
};

const AIFormulaTextarea = ({
  isLoading,
  aiFormulaQuery,
  setAiFormulaQuery,
  handleGenerateFormulaButtonClick,
  handleKeyDownGeneratePreview,
}: AIFormulaTextareaProps) => {
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    textAreaRef.current && textAreaRef.current.focus();
  }, []);

  return (
    <div>
      <Textarea
        ref={textAreaRef}
        placeholder='Generate a formula that...'
        onChange={(e) => setAiFormulaQuery(e.target.value)}
        onKeyDown={handleKeyDownGeneratePreview}
        value={aiFormulaQuery}
        className='!h-14 resize-none caret-black active:border-ocean-blue-400 focus:border-ocean-blue-500 focus:ring-2 focus:ring-midnight-100 rounded'
        disabled={isLoading}
      />
      <div className='flex justify-end my-2'>
        <Button
          variant='outline'
          color='oceanBlue'
          size='small'
          onClick={() => handleGenerateFormulaButtonClick(aiFormulaQuery)}
          disabled={!aiFormulaQuery || isLoading}
        >
          Generate Formula
        </Button>
      </div>
    </div>
  );
};

export default AIFormulaTextarea;
